import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { trackEvent } from 'Store/sparks/actions';
import { ACCOUNT_INTRO } from 'Store/sparks/sparks.events';

const useInstrumentation = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(trackEvent(ACCOUNT_INTRO));
  }, [dispatch]);
};

export default useInstrumentation;
